var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Request-Icon",
    clipPath: "url(#clip0_17_33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 149",
    d: "M19.2012 11.4688L20.911 13.1755",
    stroke: "#878EA6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 184",
    d: "M12.4652 20.0234L12.9313 17.5668L21.146 9.35193L23.1365 11.3425L14.9218 19.5574L12.4652 20.0234Z",
    stroke: "#878EA6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 362",
    d: "M19 9.70833V7.68409C19 6.92326 18.7109 6.19084 18.1913 5.63511L16.4286 3.75L14.7464 1.95102C14.1791 1.34434 13.3857 1 12.5551 1H4C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H11.2857",
    stroke: "#878EA6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 431",
    d: "M4 7H11",
    stroke: "#878EA6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 432",
    d: "M4 12H14",
    stroke: "#878EA6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 433",
    d: "M4 17H9",
    stroke: "#878EA6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 363",
    d: "M14 1V1.42857V5C14 6.10457 14.8954 7 16 7H18.6429H19",
    stroke: "#878EA6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.2d5f1a19aef6ca132b3a5d2213c7bcb6.svg";
export { ForwardRef as ReactComponent };